module.exports = __webpack_public_path__ + "9b0974f16dc3e254519c26f9414d9a41.svg";